import React, { useState } from 'react';
import { db } from '../firebase'; // adjust the path according to your file stru
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import './EmailSignupButton.css';

const EmailSignupButton = () => {
  const [expanded, setExpanded] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  const toggleExpand = () => {
    setExpanded(true);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setMessage({ type: 'error', text: 'Please enter a valid email address.' });
      return;
    }
    setIsSubmitting(true);
    setMessage(null);

    try {
      // First check if email already exists
      const subscriberRef = doc(db, 'update_list', email);
      const docSnap = await getDoc(subscriberRef);

      if (docSnap.exists()) {
        throw new Error('This email is already subscribed.');
      }

      // Save to Firestore
      await setDoc(subscriberRef, {
        email,
        subscribedAt: serverTimestamp()
      });

      setMessage({ type: 'success', text: 'Thank you for subscribing!' });
      setEmail('');
      setExpanded(false);
    } catch (error) {
      console.error('Error details:', error);
      setMessage({ type: 'error', text: error.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="email-signup-container">
      {!expanded ? (
        <button className="email-signup-button" onClick={toggleExpand}>
          Join our update list
        </button>
      ) : (
        <form className="email-signup-form" onSubmit={handleSubmit}>
          <input 
            type="email" 
            value={email} 
            onChange={handleEmailChange} 
            placeholder="Enter your email" 
            className="email-input"
            required
          />
          <button type="submit" className="email-enter-button" disabled={isSubmitting}>
            Enter
          </button>
        </form>
      )}
      {message && <p className={`message ${message.type}`}>{message.text}</p>}
    </div>
  );
};

export default EmailSignupButton;
